import { HttpRequest } from '@angular/common/http';
import { AuthorizationData } from 'fl-platform-authorizer';
import { Auth0TokenResponse, QPATResponse } from 'qp-ui-interface';
import { LocalStorageKeys } from '../LocalStorageKeys';
import { AppConfig } from '../services/config/config.service';
import { LocalStorageService } from '../services/local-storage/local-storage.service';

/**
 * Save QPAT token to local storage
 *
 * @param response
 */
export const saveXAuthToken = (response: QPATResponse, localStorage: LocalStorageService): void => {
  localStorage.setItem(LocalStorageKeys.XAUTH_TOKEN, response.token);
  localStorage.setItem(LocalStorageKeys.XAUTH_TOKEN_EXP, (Date.now() + response.expires_in * 1000).toString());
};

/**
 * Save Auth0 tokens to local storage
 *
 * @param response
 */
export const saveAccessToken = (response: Auth0TokenResponse, localStorage: LocalStorageService): void => {
  localStorage.setItem(LocalStorageKeys.ACCESS_TOKEN, response.access_token);
  localStorage.setItem(LocalStorageKeys.ID_TOKEN, response.id_token);
  localStorage.setItem(LocalStorageKeys.REFRESH_TOKEN, response.refresh_token);
  localStorage.setItem(LocalStorageKeys.REFRESH_TOKEN_EXP, (Date.now() + response.expires_in * 1000).toString());
};

/**
 * Save auth data tokens to local storage
 *
 * @param response
 */
export const saveAuthDataToken = (response: AuthorizationData, localStorage: LocalStorageService): void => {
  localStorage.setItem(LocalStorageKeys.AUTHDATA, response.accessToken);
  localStorage.setItem(LocalStorageKeys.AUTHDATA_TOKEN_EXP, (Date.now() + response.tokenExpiresInSeconds * 1000).toString());
};

/**
 * Check if should include 'Authorization' header
 *
 * @param request
 * @param applicationConfig
 * @returns
 */
export const includeAuthHeader = (request: HttpRequest<any>, applicationConfig: AppConfig) => {
  return (
    request.url.includes(applicationConfig.umsURL) ||
    request.url.includes(applicationConfig.guestFlatURL) ||
    request.url.includes(applicationConfig.geoLocationURL)
  );
};
